//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HTTP from "@/http-common";

function filterGenotype(organisms, genotypes, type) {
  console.log("filterGenotype");
  console.log(type);
  let f;
  if (type == "all") {
    f = (org) => genotypes.every((gene) => org.genotype.includes(gene));
  } else if (type == "any") {
    f = (org) => genotypes.some((gene) => org.genotype.includes(gene));
  } else if (type == "exact") {
    f = (org) => genotypes.sort().join(", ") == org.genotypeText;
  } else {
    throw "ValueError";
  }
  return organisms.filter(f);
}

function filterPhylum(organisms, phylums) {
  console.log("filterPhylum");
  return organisms.filter((org) =>
    phylums.some((phylum) => org.phylum == phylum)
  );
}

function filterKingdoms(organisms, kingdoms) {
  console.log("filterKingdoms");

  return organisms.filter((org) =>
    kingdoms.some((kingdom) => org.kingdom == kingdom)
  );
}

export default {
  props: {
    genesToFilterProp: {
      type: Object,
      default: () => ({ values: [], type: "any" }),
    },
    phylumsToFilterProp: {
      type: Array,
      default: () => [],
    },
    kingdomsToFilterProp: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      drawer: null,
      search: "",
      headers: [
        { text: "Organism", value: "name" },
        { text: "Phylum", value: "phylum" },
        { text: "Kingdom", value: "kingdom" },
        { text: "Genotype", value: "genotypeText" },
      ],
      organisms: [],
      filteredOrganisms: [],
      genesToFilter: this.genesToFilterProp,
      phylumsToFilter: this.phylumsToFilterProp,
      kingdomsToFilter: this.kingdomsToFilterProp,
      height: 100,
    };
  },
  computed: {
    genesInItems() {
      return this.genesToFilter.values.every((gene) =>
        this.allGenotypeGenes.includes(gene)
      );
    },
    phylumsInItems() {
      return this.phylumsToFilter.every((phylum) =>
        this.allPhylums.includes(phylum)
      );
    },
    kingdomsInItems() {
      return this.phylumsToFilter.every((phylum) =>
        this.allPhylums.includes(phylum)
      );
    },

    allGenotypeGenes() {
      return Array.from(
        new Set(this.organisms.map((org) => org.genotype).flat())
      ).sort();
    },
    allPhylums() {
      return Array.from(
        new Set(this.organisms.map((org) => org.phylum).flat())
      );
    },
    allKingdoms() {
      return Array.from(
        new Set(this.organisms.map((org) => org.kingdom).flat())
      );
    },
    toggleButtonText() {
      return this.drawer ? "Hide Filters" : "Show Filters";
    },
  },

  methods: {
    resetFilters() {
      this.genesToFilter.values = [];
      this.genesToFiler.type = "any";
      this.phylumsToFilter = [];
      this.kingdomsToFilter = [];
      this.filteredOrganisms = this.organisms;
    },
    applyFilters() {
      let organisms = this.organisms;
      console.log([
        this.kingdomsToFilter,
        this.phylumsToFilter,
        this.genesToFilter,
      ]);
      console.log(this.kingdomsToFilter.length);
      if (this.kingdomsToFilter.length) {
        console.log("filter kingdoms");
        organisms = filterKingdoms(organisms, this.kingdomsToFilter);
      }
      if (this.phylumsToFilter.length) {
        organisms = filterPhylum(organisms, this.phylumsToFilter);
      }
      if (this.genesToFilter.values.length) {
        organisms = filterGenotype(
          organisms,
          this.genesToFilter.values,
          this.genesToFilter.type
        );
      }

      this.filteredOrganisms = organisms;
    },
    toggleFilters() {
      this.drawer = !this.drawer;
    },
  },

  mounted: function() {
    HTTP.get(`organisms`)
      .then((response) => {
        // JSON responses are automatically parsed.
        this.organisms = response.data.map((org) => ({
          ...org,
          genotypeText: org.genotype.sort().join(", "),
        }));
        this.filteredOrganisms = this.organisms;
        this.applyFilters();
      })
      .catch((error) => {
        console.warn(error);
      });
    window.scrollTo(0, 0);
  },
};
